import CustomerHelper from '@/helpers/customerHelper';
import { CrudService } from '@/services/crudService';

function ensureTrailingSlash(baseUrl: string): string {
  if (!baseUrl) {
    return '';
  }
  return baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
}

type ClassSlotLike = {
  placeId?: string | number | null;
  placeID?: string | number | null;
  place?: { id?: string | number | null } | null;
} & Record<string, unknown>;

type ClassDataLike = {
  classId?: number | string | null;
  tenantUrl?: string | null;
  slots?: ClassSlotLike[] | null;
  bookings?: ClassSlotLike[] | null;
} & Record<string, unknown>;

interface JoinClassOptions {
  slot?: ClassSlotLike | null;
}

export async function joinClass(classData: ClassDataLike, options: JoinClassOptions = {}) {
  if (!classData?.classId) {
    throw new Error('Clase no válida');
  }

  const user = CustomerHelper.getUser();
  if (!user) {
    throw new Error('Usuario no autenticado');
  }

  const tenantUrl: string = classData.tenantUrl ?? '';
  if (!tenantUrl) {
    throw new Error('Tenant sin URL configurada');
  }

  const slot = options.slot
    || (Array.isArray(classData.slots) ? classData.slots[0] : null)
    || (Array.isArray(classData.bookings) ? classData.bookings[0] : null);
  if (!slot) {
    throw new Error('No hay franjas disponibles para esta clase');
  }

  const endpointBase = ensureTrailingSlash(tenantUrl);
  const placeId = slot.placeId ?? slot.placeID ?? slot.place?.id;
  const prebookPlaceBaseUrl = `${endpointBase}/api/publicbookings/byplace-prebook-place/0/${classData.classId}`;
  const prebookPlaceUrl = placeId ? `${prebookPlaceBaseUrl}/${placeId}` : prebookPlaceBaseUrl;

  const crud = new CrudService({
    baseUrl: '',
    allowAuth: true,
    handleUnauthorized: false,
  });
  const response = await crud.httpPost(prebookPlaceUrl, null, undefined, 'json', {
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
    },
    handleUnauthorized: false,
  });

  return response;
}
